module.exports = __webpack_public_path__ + "img/timeline_miscevent-16.2fa586f6.jpg";